<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-account-group"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="white mx-1">
        <v-row class="mt-4 ml-4">
          <v-col cols="12" class="text-right mb-5 pr-6">
            <v-btn
              class="btn-add-templates"
              @click="addTemplate"
          >
            Add Template Size
          </v-btn>
          </v-col>
        </v-row>
        <v-col cols="12" class="mt-n2">
          <v-data-table
              :headers="headers"
              :items="customDesign"
              :sort-by="['id']"
              :sort-desc="true"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.img_url="{ item }">
              <div class="img">
                <img :src="item.img_url" alt="">
              </div>
            </template>
<!--            <template v-slot:item.actions="{ item }">-->
<!--              <v-icon small class="mr-2" @click="viewItem(item.user_id)">-->
<!--                mdi-eye-->
<!--              </v-icon>-->
<!--            </template>-->
          </v-data-table>
        </v-col>
      </v-row>
      <v-dialog
          v-model="dialog"
          v-if="dialog"
          max-width="600px"
          persistent
      >
        <v-card>
          <div class="text-h5 px-12 pt-12">Choose Templates</div>
          <v-card-text>
            <v-row align="center" justify="center" class="pa-5 text--primary">
              <v-col cols="12">
                <v-combobox
                v-model="template_template_sizes"
                :items="templateTemplateSizes"
                item-text="name"
                item-value="id"
                label="Name"
                multiple
                clearable
                >
                </v-combobox>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="pa-5">
            <v-row align="center" justify="center" class="my-5 mr-5">
              <v-btn class="btn-cancel" color="#F5F5F5" @click="dialog = false">CANCEL</v-btn>
              <v-btn class="btn-save" color="#71BEC8" @click="save">SAVE</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import {GET_LIST_TEMPLATE, SAVE_CUSTOM_DESIGN,GET_CUSTOM_DESIGN} from "@/store/modules/custom_design";
import {mapGetters} from "vuex";

export default {
  name: "CustomTemplateSetting",
  data() {
    return {
      page: "Custom Template Setting",
      breadcrumbs: [
        {
          text: "Custom Template Setting",
          disabled: false,
        },
      ],
      date: '',
      headers: [
        {text: "Image", value: "img_url"},
        {text: "Name", value: "name"},
        // {text: "Actions", value: "actions", sortable: false},
      ],
      row: 1,
      dialog: false,
      template_template_sizes:[]
    }
  },
  computed: {
    ...mapGetters({
      templateTemplateSizes: "templateTemplateSizes",
      customDesign: "customDesign"
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_TEMPLATE);
    await this.$store.dispatch(GET_CUSTOM_DESIGN).then(data => {
      if(data.data) {
        this.template_template_sizes = data.data
      }
    });
  },
  methods: {
    addTemplate() {
      this.dialog = true
    },
    async save() {
      let template_template_size_ids = this.template_template_sizes.map(el => {return el.id});
      await this.$store.dispatch(SAVE_CUSTOM_DESIGN, {template_template_size_ids:template_template_size_ids});
      await this.$store.dispatch(GET_CUSTOM_DESIGN)
      this.dialog = false;
    }
  }
}
</script>

<style scoped>
.btn-cancel {
  width: 102px;
  height: 40px;
  color: #585858;
  border: 1px solid #8C8C8C;
  border-radius: 6px;
  font-size: 16px;
  background: #F5F5F5;
  box-shadow: #00000040;
  margin-right: 6px;
}
.btn-save {
  width: 102px;
  height: 40px;
  color: #fff;
  border: 1px solid #8C8C8C;
  border-radius: 6px;
  font-size: 16px;
  box-shadow: #00000040;
  margin-left: 6px;
}
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}
.img img {
  width: 100px;
}
</style>